import styled from 'styled-components';
import { darkBlue, roboto } from '../../../utils/theme';

export const CopyrightText = styled.p`
  color: ${darkBlue};
  ${roboto};
  font-weight: 400;
  letter-spacing: 3px;
  font-size: 12px;
  text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./src/components/copyright/styles/copyright.style.js